export default __webpack_public_path__ + "static/background-64c5a1f504ee1d353ac3b8a853fac250.webm";